import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";
import { brand } from "../mock";

export default function AuthPage({ mode = "signin" }) {
  const isSignup = mode === "signup";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    localStorage.setItem("reviewuk_user", JSON.stringify({ name: name || email.split("@")[0], email }));
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-[#f5f7f8] font-[Inter,system-ui,-apple-system,sans-serif] flex flex-col">
      <Header />
      <Breadcrumb trail={[{ label: "Home", to: "/" }, { label: isSignup ? "Sign up" : "Sign in" }]}/>

      <main className="flex-1">
        <div className="max-w-[440px] mx-auto px-4 py-10">
          <div className="bg-white border border-gray-200 rounded-lg p-7">
            <div className="flex items-center gap-2 mb-1">
              <div className="w-9 h-9 bg-[#f5a623] rounded-md flex items-center justify-center font-black text-[#003844]">RU</div>
              <div className="font-bold text-gray-900">{brand.name}</div>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mt-3">
              {isSignup ? "Create your account" : "Welcome back"}
            </h1>
            <p className="text-sm text-gray-500 mt-1">
              {isSignup ? "Join the community and start posting reviews." : "Sign in to manage your reviews."}
            </p>

            <form onSubmit={submit} className="mt-5 space-y-3">
              {isSignup && (
                <div>
                  <label className="text-xs font-semibold text-gray-700">Display name</label>
                  <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 text-sm outline-none focus:border-[#007a8a] focus:ring-2 focus:ring-[#007a8a]/20"
                  />
                </div>
              )}
              <div>
                <label className="text-xs font-semibold text-gray-700">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 text-sm outline-none focus:border-[#007a8a] focus:ring-2 focus:ring-[#007a8a]/20"
                />
              </div>
              <div>
                <label className="text-xs font-semibold text-gray-700">Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  minLength={6}
                  className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 text-sm outline-none focus:border-[#007a8a] focus:ring-2 focus:ring-[#007a8a]/20"
                />
              </div>
              <button
                type="submit"
                className="w-full bg-[#007a8a] hover:bg-[#005f6b] transition-colors text-white font-semibold text-sm px-4 py-2.5 rounded-md"
              >
                {isSignup ? "Create account" : "Sign in"}
              </button>
            </form>

            <p className="text-xs text-gray-500 mt-4 text-center">
              {isSignup ? (
                <>Already have an account? <Link to="/signin" className="text-[#007a8a] hover:underline font-medium">Sign in</Link></>
              ) : (
                <>New to {brand.name}? <Link to="/signup" className="text-[#007a8a] hover:underline font-medium">Create an account</Link></>
              )}
            </p>
            <p className="text-[11px] text-gray-400 mt-3 text-center">
              Auth is mocked locally — no real account is created.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
